'use client'

/**
 * Tiny external store that lets a PAGE hand the layout-level WhatsApp float a
 * page-specific contact (the property's own WhatsApp number and localized
 * name). The float lives in the booking layout, outside the page tree, so
 * ordinary props can't reach it; a page mounts `<WhatsAppPropertyOverride>`
 * which writes here, and clears it on unmount.
 */

import { useSyncExternalStore } from 'react'

export interface WhatsAppOverride {
  /** Raw social-link value (URL or phone) for THIS property, if it has one. */
  whatsapp: string | null
  /** Localized property name for the prefilled message. */
  propertyName: string
}

let override: WhatsAppOverride | null = null
const listeners = new Set<() => void>()

export function setWhatsAppOverride(next: WhatsAppOverride | null) {
  override = next
  listeners.forEach((l) => l())
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => override
const getServerSnapshot = () => null

export function useWhatsAppOverride(): WhatsAppOverride | null {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
